module.exports = __webpack_public_path__ + "static/media/Logo_Excel.efa97eb1.svg";